import {useCallback, useEffect, useState} from "react";
import {API_COMPANY} from "../const/Api";
import {Get} from "../lib/Request"

// Custom hook for managing offices
function useOffices() {
  const [offices, setOffices] = useState([]);
  const [loadingOffices, setLoadingOffices] = useState(true);

  const fetchOffices = useCallback(async () => {
    setLoadingOffices(true);
    try {
      const result = await Get(API_COMPANY);
      if (result?.data) {
        setOffices(result.data);
      } else {
        setOffices([]);
      }
    } catch (error) {
      console.error("Error fetching offices:", error);
      setOffices([]);
    } finally {
      setLoadingOffices(false);
    }
  }, []);

  useEffect(() => {
    fetchOffices();
  }, [fetchOffices]);

  return {offices, loadingOffices, fetchOffices};
}

export default useOffices;